exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WZseo{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.WZseo:hover{opacity:.7}._3655N{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1kYCx{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:25px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1npjZ{font-size:12px}div[data-hook=player-container][data-in-full-screen=true] ._1npjZ{font-size:14px}._121H3{margin-left:5px}._121H3:before{margin-right:4px;content:\"/\"}.GuENv ._121H3,.GuENv .STS-Q{display:none}", ""]);

// exports
exports.locals = {
	"controlButton": "WZseo",
	"hidden": "_3655N",
	"timeWrapper": "_1kYCx",
	"time": "_1npjZ",
	"duration": "_121H3",
	"liveMode": "GuENv",
	"separator": "STS-Q"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!../node_modules/playable/dist/src/modules/ui/controls/time/time.scss
// module id = 191
// module chunks = 0